module.exports = __webpack_public_path__ + "img/7c_Cameras.2aff8aa9.png";